import {useDark, useToggle } from '@vueuse/core'

export const isDark = useDark({
    selector: 'html',
    attribute: 'data-theme',
    valueDark: 'dark',
    valueLight: 'light'
})

export const toggleTheme = () => {
    useToggle(isDark)()
    if(isDark.value) {
        document.documentElement.classList.add('dark')
        document.documentElement.classList.remove('light')
    } else {
        document.documentElement.classList.add('light')
        document.documentElement.classList.remove('dark')
    }
}

export const setLight = () => {
    if(isDark.value)
        toggleTheme()
}
export const setDark = () => {
    if(!isDark.value)
        toggleTheme()
}